<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="소스 파일 등록 문의 조회"
      desc="소스 파일 등록 문의 내역을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
        <div slot="status" slot-scope="props">{{ statusKor(props.item.status) }}</div>
        <div slot="title" slot-scope="props">
          <div class="prop-title" @click="clickItem(props.item)">{{ props.item.title }}</div>
        </div>
        <div slot="created_time" slot-scope="props">{{ datesFormat(props.item.created_time, 'date_time_2') }}</div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from "../../../../mixins/ListMixin";

  export default {
    name: "SourceInquiryList",
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {}
    },
    methods: {
      clickItem(item) {
        this.routerPush(`/office/admin/launchpack/templates/inquiry/detail?id=${item.id}`);
      },
      init() {
        this.initializing('source_inquiry', 'inquiry/source');
      },
      getDataFromServer() {
        this.getData();
      },
      statusKor(status) {
        return {
          0: '문의내용 확인중',
          1: '파일 등록 완료'
        }[status];
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .prop-title
    text-decoration underline
    cursor pointer

</style>
